import { BASE_URL } from './constants';

// The upload API used to return bare filenames (served from /upload/<name>) and now
// returns full CDN URLs. Accept both so absolute URLs are not double-prefixed.
export const toUploadUrl = (nameOrUrl) => (/^https?:\/\//i.test(nameOrUrl) ? nameOrUrl : `${BASE_URL}/upload/${nameOrUrl}`);
